export default __webpack_public_path__ + "static/media/ldo_FIX_EN.35f4199e.svg";